import { Component, OnInit } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdDialogService } from '@covalent/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { CollectionService } from '../../../shared/services/collection.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { DesignService } from '../../../shared/services/design.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-designs-list',
  templateUrl: './designs-list.component.html',
  styleUrls: ['./designs-list.component.scss'],
  providers: [DesignService]
})
export class DesignsListComponent implements OnInit {
  data: any[];

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Design name' },
    { name: 'collection_name', label: 'Collection' },
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  
  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: MdDialog,
    private _loadingService: TdLoadingService,
    private _designService: DesignService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService) { }

  ngOnInit() {
    this._loadingService.register('loading');
    
    this._designService.getDesigns().subscribe(
      response => {
        console.log(response);
        this.data = response;
      },
      error => {
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');        
        this.filter();
      }
    );
  }

  openAddNewDesignDialog() {
    this._dialogService.open(NewDesignDialog).afterClosed().subscribe(
      result => {
        if (result != null) {
          this.data.push(result);
          this.filter();
        }
      }
    );
  }

  deleteSelected() {
    this._loadingService.register('loading');
    
    this.selectedRows.forEach(
      (design) => {
        this._designService.removeDesign(design.id).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.data = this.data.filter( function(c) { return c['id'] != response['id'] } );
            } else {
              console.log('Could not delete ' + design.name);
            }
          },
          error => {
            console.log(error);
          },
          () => {
            this._loadingService.resolve('loading');
            
            this.filter();
          }
        );
      }
    );

    this.selectedRows = [];
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}


@Component({
  selector: 'new-design-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <h4>Enter new design name and collection</h4>
      <md-divider></md-divider>
      <md-input-container>
        <input mdInput type="text" placeholder="Design Name" [(ngModel)]="name">
      </md-input-container>
      <md-select fxFlex="22%" placeholder="Collection" [(ngModel)]="collection_id">
        <md-option *ngFor="let collection of collections" [value]="collection.id">{{collection.name}}</md-option>
      </md-select>
      <div flex layout="row" layout-wrap>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="addDesign()">Add</button>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="dialogRef.close()">Close</button>
      </div>
    </div>
  `,
})
export class NewDesignDialog implements OnInit {
  collections: any[] = [];

  name: string = '';
  collection_id: number = 0;

  constructor(public dialogRef: MdDialogRef<NewDesignDialog>,
    private tdDialog: TdDialogService,
    private _collectionService: CollectionService,
    private _designService: DesignService) { }

  ngOnInit() {
    this._collectionService.getCollections().subscribe(
      response => {
        console.log(response);
        this.collections = response;
      },
      error => {
        console.log(error)
      },
      () => { }
    );
  }

  addDesign() {
    this._designService.addDesign({ name: this.name, collection_id: this.collection_id }).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'City added successfully'
            }
          );
          this.dialogRef.close({ name: this.name, collection_id: this.collection_id });
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add city'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );

  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/designs-list/designs-list.component.ts